export default __webpack_public_path__ + "static/media/cafeRichard.197baa8f.png";